/*  FAQ accordion + live-search for Dawn theme  -------------------------------
    Markup assumed (see Step 2):
      .faq-group      – category wrapper
      .faq-title      – clickable heading
      .faq-item       – wrapper for each Q&A
      .faq-question   – clickable question
      .faq-answer     – answer text (starts hidden)

    Behaviour:
      • All groups collapsed on load.
      • Clicking a group heading toggles its questions.
      • Clicking a question toggles its answer (multiple answers may stay open).
      • Live search filters questions + reveals matching groups.
----------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const groups = document.querySelectorAll('.faq-group');
  const searchInput = document.getElementById('faqSearch');

  /* ---------- Initialise: collapse everything ---------- */
  groups.forEach(group => {
    group.classList.remove('is-open');                         // collapse group
    group.querySelectorAll('.faq-answer').forEach(ans => ans.style.display = 'none');
  });

  /* ---------- Group toggle (sub-heading) ---------- */
  groups.forEach(group => {
    const title = group.querySelector('.faq-title');
    title.addEventListener('click', () => {
      group.classList.toggle('is-open');
    });
  });

  /* ---------- Question toggle (answer reveal) ---------- */
  groups.forEach(group => {
    group.querySelectorAll('.faq-item').forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer   = item.querySelector('.faq-answer');
      question.addEventListener('click', () => {
        const open = item.classList.toggle('is-open');
        answer.style.display = open ? 'block' : 'none';        // multiple can stay open
      });
    });
  });

  /* ---------- Live search ---------- */
  const debounce = (fn, ms = 200) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  const runSearch = () => {
    const q = searchInput.value.trim().toLowerCase();

    groups.forEach(group => {
      let groupHasMatch = false;

      group.querySelectorAll('.faq-item').forEach(item => {
        const text = (item.querySelector('.faq-question').textContent +
                      ' ' +
                      item.querySelector('.faq-answer').textContent).toLowerCase();
        const match = q && text.includes(q);

        // Show / hide each item
        item.classList.toggle('is-hidden', q && !match);

        if (match) groupHasMatch = true;
      });

      /* Show or hide group & force-open if it contains a match */
      if (!q) {
        group.classList.remove('is-hidden', 'is-open');
        group.classList.remove('is-open');
      } else {
        group.classList.toggle('is-hidden', !groupHasMatch);
        group.classList.toggle('is-open', groupHasMatch);      // auto-expand matches
      }
    });
  };

  searchInput.addEventListener('keyup', debounce(runSearch, 150));
});
